<template>
  <transition name="fade">
    <div class="g-alert" v-if="isVisible">
      <b-icon-exclamation-triangle variant="white" class="icon h2 m-2 ml-3"></b-icon-exclamation-triangle>
      <div class="text">{{ message }}</div>
    </div>
  </transition>
</template>

<script>
import { BIconExclamationTriangle } from "bootstrap-vue";
export default {
  name: "GlobalAlert",
  components: {
    BIconExclamationTriangle,
  },
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    "visible": {
      type: Boolean,
      default: false
    },
    "message": {
      type: String,
      default: ""
    },
    "delay": {
      type: Number,
      default: 10000
    }
  },
  data() {
    return {
      isVisible: false,
      timeOutId: null
    };
  },  
  watch: {
    visible(newVal, oldVal) {
      if (newVal !== oldVal) {
        this[newVal ? 'show' : 'hide']()
      }
    }
  },    
  methods: {
    show() {
      if (!this.isVisible) {
        document.body.appendChild(this.$el);
        this.isVisible = true;
        this.timeOutId = setTimeout(() => {
          this.hide();
        }, this.delay);
      }
    },
    hide() {
      if (this.isVisible) {
        if (this.timeOutId) {
          clearTimeout(this.timeOutId);
          this.timeOutId = null;
        }
        this.$el.parentNode.removeChild(this.$el);
        this.isVisible = false;
        this.$emit("hide");
      }
    },   
  },
  mounted() {
    // remove the element from the DOM
    if (this.$el.parentNode) this.$el.parentNode.removeChild(this.$el);
    // Initially show modal?
    if (this.visible === true) {
      this.$nextTick(this.show)
    }
  }
};
</script>

<style scoped>
.g-alert {
  position: fixed;
  z-index: 10000;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: brown;
  display: flex;
}
.g-alert .text {
  display: flex;
  flex-direction: column;
  justify-content: center;  
  color: white;
  font-size: 15px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
</style>